import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const HOURS = Array.from({ length: 24 }, (_, i) => String(i).padStart(2, "0"));
const MINUTES = ["00", "15", "30", "45"];

// value: "HH:MM" | ""  ; onChange("HH:MM")
export const TimeSelect = ({ value, onChange, testid }) => {
  const [h, m] = value ? value.split(":") : ["", ""];

  const setPart = (part, v) => {
    const hh = part === "h" ? v : h || "00";
    const mm = part === "m" ? v : m || "00";
    onChange(`${hh}:${mm}`);
  };

  return (
    <div className="flex items-center gap-2">
      <Select value={h || ""} onValueChange={(v) => setPart("h", v)}>
        <SelectTrigger data-testid={`${testid}-hour`} className="h-14 rounded-xl text-lg font-semibold">
          <SelectValue placeholder="Ora" />
        </SelectTrigger>
        <SelectContent className="max-h-64">
          {HOURS.map((x) => (
            <SelectItem key={x} value={x} className="text-lg">
              {x}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <span className="text-2xl font-bold text-slate-400">:</span>
      <Select value={m || ""} onValueChange={(v) => setPart("m", v)}>
        <SelectTrigger data-testid={`${testid}-minute`} className="h-14 rounded-xl text-lg font-semibold">
          <SelectValue placeholder="Min" />
        </SelectTrigger>
        <SelectContent>
          {MINUTES.map((x) => (
            <SelectItem key={x} value={x} className="text-lg">
              {x}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
